/* eslint-disable react/no-children-prop */
import React, { useEffect } from 'react';
import { withStyles, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { ArrowBack } from '@material-ui/icons';
import { VentaPaginacion } from '../../subcomponents';
import { Validate } from '../../../../other/validate';
import useWindowSize from '../../../amplitude/useWindowSize';

const VentaBotonesNavegacion_ = (props) => {
  let history = useHistory();

  const { width } = useWindowSize();

  const msg_button = () =>
    Validate.is_mobile() ? (
      ''
    ) : (
      <span className={classes.button_text}>Volver</span>
    );

  //Se usa para detectar el cambio de resolución
  useEffect(() => {}, [width]);

  const arrowBack = (classes) => (
    <>
      <ArrowBack />
      {msg_button()}
    </>
  );

  const arrow_left = (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.41 1.41L6 0L0 6L6 12L7.41 10.59L2.83 6L7.41 1.41Z"
        fill="#383838"
      />
    </svg>
  );

  const arrow_right = (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.00009 0L0.590088 1.41L5.17009 6L0.590088 10.59L2.00009 12L8.00009 6L2.00009 0Z"
        fill="#383838"
      />
    </svg>
  );

  const {
    classes,
    venta_id,
    ultimo_venta_id,
    handleVentaAnterior,
    handleVentaSiguiente,
  } = props;

  return (
    <>
      <div className={classes.container}>
        <div>
          <Button
            className={classes.button_back}
            children={arrowBack(classes)}
            fullWidth={false}
            variant="text"
            onClick={(e) => history.push('/ventas')}
          />
        </div>
        <div className={classes.paginator_container}>
          <VentaPaginacion
            firstvalue={venta_id}
            lastvalue={'de ' + ultimo_venta_id}
          />
          <Button
            className={classes.button}
            children={arrow_left}
            fullWidth={false}
            variant="text"
            onClick={(e) => handleVentaAnterior()}
            disabled={venta_id === 1}
          />
          <Button
            className={classes.button}
            children={arrow_right}
            fullWidth={false}
            variant="text"
            onClick={(e) => handleVentaSiguiente()}
            disabled={venta_id === ultimo_venta_id}
          />
        </div>
      </div>
      <div className={classes.divider}></div>
    </>
  );
};

const styles = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '16px',
  },
  paginator_container: {
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    color: '#383838',
    '&:disabled svg path': {
      fill: '#8F8F8F',
    },
  },
  button_back: {
    color: '#383838',
    justifyContent: 'start',
    paddingLeft: 'initial',
  },
  divider: {
    borderBottom: '1px solid #CDCDCD',
    color: '#CDCDCD',
    marginBottom: '25px',
  },
  button_text: {
    fontSize: '14px',
    paddingLeft: '8px',
    textTransform: 'capitalize',
  },
});

export const VentaBotonesNavegacion = withStyles(styles)(
  VentaBotonesNavegacion_
);
